/**
 * Dashboard template configurations
 * Defines which widgets are displayed for each template
 */

export type WidgetId =
  | 'market-value'
  | 'fsv'
  | 'reliability'
  | 'subject-property'
  | 'comparable-properties'
  | 'map-view'
  | 'audit-export';

export interface DashboardTemplate {
  id: string;
  name: string;
  description: string;
  widgets: WidgetId[];
}

export const DASHBOARD_TEMPLATES: Record<string, DashboardTemplate> = {
  valuation: {
    id: 'valuation',
    name: 'Valuation Dashboard',
    description: 'Property valuation with market analysis and comparable properties',
    widgets: [
      'subject-property',
      'market-value',
      'fsv',
      'reliability',
      'comparable-properties',
      'map-view',
      'audit-export',
    ],
  },
  // Future templates will be added here:
  // 'market-analysis': { ... },
  // 'portfolio': { ... },
};

export const DEFAULT_TEMPLATE_ID = 'valuation';

